const ApplicationException = require('exceptions/ApplicationException');
const ArgumentException = require('exceptions/ArgumentException');
const ArgumentNullException = require('exceptions/ArgumentNullException');
const ArgumentOutOfRangeException = require('exceptions/ArgumentOutOfRangeException');

module.exports = {
    ApplicationException,
    ArgumentException,
    ArgumentNullException,
    ArgumentOutOfRangeException
};
